module.exports = __webpack_public_path__ + "media/img/home/gallery/gallery10-f5d32545344afad5cb923c1a547d04f6.png";